import { connect } from 'react-redux';
import MyTabs from './../../components/myTabs/myTabs';
import { getMyTabs } from './../../actions/tabActions';

const mapStateToProps = state => {
  return {
    myTabs: state.tab.get('myTabs')
  };
};

const mapDispatchProps = dispatch => {
  return {
    getMyTabs: () => {
      dispatch(getMyTabs());
    }
  }
};

const MyTabsView = connect(mapStateToProps, mapDispatchProps)(MyTabs);

export default MyTabsView;



// WEBPACK FOOTER //
// ./src/views/myTabsView/myTabsView.js